import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  jobList: [],
  jobCategoryList: [],
  selectJobs: "",
  selectJobCategory: "",
  gazetteList: [],
  selectGazette: "",
};

const JobsReducer = createSlice({
  name: "JobsReducer",
  initialState: initialState,
  reducers: {
    setJobList: (state, { payload }) => {
      return {
        ...state,
        jobList: payload,
      };
    },

    setJobs: (state, { payload }) => {
      return {
        ...state,
        selectJobs: payload,
      };
    },

    setJobCategoryList: (state, { payload }) => {
      return {
        ...state,
        jobCategoryList: payload,
      };
    },

    setJobCategory: (state, { payload }) => {
      return {
        ...state,
        selectJobCategory: payload,
      };
    },

    setGazetteList: (state, { payload }) => {
      return {
        ...state,
        gazetteList: payload,
      };
    },

    setGazette: (state, { payload }) => {
      return {
        ...state,
        selectGazette: payload,
      };
    },

    updateJobCategory: (state, { payload }) => {
      console.log("payload", payload);

      let newList = [...state.jobCategoryList];
      console.log("newList", newList);
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].job_category_id === payload.job_category_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        jobCategoryList: newList,
      };
    },

    clearedSelectJobs: (state) => {
      return {
        ...state,
        selectJobs: "",
      };
    },
  },
});
export default JobsReducer;
